import { render, staticRenderFns } from "./IneaInfoModal.vue?vue&type=template&id=669eb8df&scoped=true&lang=pug&"
import script from "./IneaInfoModal.vue?vue&type=script&lang=js&"
export * from "./IneaInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669eb8df",
  null
  
)

export default component.exports